import React from "react";
import LazyImage from "../Shared/LazyImage";

const ExternalProfileHeader = ({ editAction, image, editColor }) => {
    return (
        <>
            <div className="user-header">
                <div className="choose-img-wrapper user-img">
                    <LazyImage
                        src={
                            image ||
                            require("../../assets/images/org-avatar-bg.png")
                                .default
                        }
                        alt="UserImage"
                    />
                </div>
                {editAction && (
                    <div className="edit-theme" onClick={editAction}>
                        <i
                            className="fas fa-edit cursor-pointer theme-editor"
                            style={{ color: editColor }}
                        ></i>
                    </div>
                )}
            </div>
        </>
    );
};

export default ExternalProfileHeader;
